import { Vue, Component } from 'vue-property-decorator'
import StatisticalAnalysisHeader from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.vue'
import {
    StatisticalAnalysisGeneralDossierModelSearchInfo,
    StatisticsAnalysisGeneralStatisticsTrackingItems,
    StatisticalAnalysisDossierGeneralStatisticsState,
    initialStatisticalAnalysisDossierGeneralStatisticsState
} from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import StatisticalAnalysisSidebar from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.vue'
import { generalStatisticsDossierService } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.service'
import { StatisticalAnalysisGeneralStatisticsDossierBaseRequest, StatisticalAnalysisGeneralStatisticsDossierCase, StatisticalAnalysisGeneralStatisticsDossierCaseVirtualState } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.dto'
import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { capitalize, isNil } from 'lodash'
import StatisticalAnalysisGeneralStatisticsGeneral from '@/modules/statistical-analysis-module/components/statistical-analysis-general-statistics-general/statistical-analysis-general-statistics-general.vue'
import StatisticalAnalysisGeneralStatisticsDetail from '@/modules/statistical-analysis-module/components/statistical-analysis-general-statistics-detail/statistical-analysis-general-statistics-detail.vue'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisCaseTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import StatisticalAnalysisSkeletonGeneralDossierBase from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-general-dossier/statistical-analysis-skeleton-general-dossier-base/statistical-analysis-skeleton-general-dossier-base.vue'
import { getIconHeaders } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
@Component({
    components: {
        StatisticalAnalysisSidebar,
        StatisticalAnalysisHeader,
        StatisticalAnalysisGeneralStatisticsGeneral,
        StatisticalAnalysisGeneralStatisticsDetail,
        StatisticalAnalysisSkeletonGeneralDossierBase
    }
})
export default class StatisticalAnalysisDossier extends Vue {
    state: StatisticalAnalysisDossierGeneralStatisticsState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisDossierGeneralStatisticsState()
    }

    get isInitDossier(): boolean {
        return !isNil(this.state.promiseGeneralView)
    }

    get isGeneralView(): boolean {
        return this.state.generalView
    }

    get getLabelSelected(): string {
        const entitySelected = this.state.externalInfo.typeSearch?.text as string
        const entityStateSelected = this.state?.externalInfo.trackingGeneralSelected?.label!
        return this.$tc(`statisticalAnalysis.dossiers.entityTypeStatusSelection`, undefined, { entityType: capitalize(this.$tc(entitySelected, 2)), state: capitalize(entityStateSelected) })
    }

    get isGeneralItemSelected(): boolean {
        return !!this.state.externalInfo.trackingGeneralSelected
    }

    showSpecificView(item: StatisticsAnalysisGeneralStatisticsTrackingItems): void {
        this.state = {
            ...this.state,
            generalView: false,
            externalInfo: {
                ...this.state.externalInfo,
                trackingDetailSelected: item
            }
        }
    }

    onItemSelected(itemSelected: StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes>): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                trackingGeneralSelected: itemSelected,
                trackingItems: []
            },
            generalView: true
        }
    }

    onBackView(): void {
        this.state.generalView = true
    }

    onClickView(itemSelected: StatisticsAnalysisGeneralStatisticsTrackingItems): void {
        this.showSpecificView(itemSelected)
    }

    onChangeSameRange(value: boolean): void {
        this.state.externalInfo.sameRange = value
    }

    onSearch(search: StatisticalAnalysisGeneralDossierModelSearchInfo): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                startDate: search.startDate,
                endDate: search.endDate,
                typeSearch: search.typeSearch,
                laboratories: search.laboratories,
                trackingGeneralSelected: null,
                trackingItems: [],
                typeIds: search.typeIds
            },
            generalView: true,
            headerData: {
                ...this.state.headerData,
                header: {
                    ...this.state.headerData.header,
                    startDate: search.startDate as Date,
                    endDate: search.endDate as Date,
                    elementType: search.typeSearch!.text
                },
                navigationItems: [],
                styles: {
                    ...this.state.headerData.styles,
                    icon: getIconHeaders(search.typeSearch?.id as StatiscalAnalysisTypeCases)
                }
            },
            viewDetail: {
                ...this.state.viewDetail,
                chart: {
                    ...this.state.viewDetail.chart,
                    axis: {
                        ...this.state.viewDetail.chart.axis,
                        xAxis: {
                            ...this.state.viewDetail.chart.axis.xAxis,
                            mainCombo: {
                                list: [],
                                selected: null
                            },
                            associatedCombo: {
                                list: [],
                                selected: null
                            }
                        }
                    }
                }
            }
        }
        this.state.promiseGeneralView = this._getInfoGeneralViewNavigationItems()
    }

    onTrackingItemsLoaded(values: StatisticsAnalysisGeneralStatisticsTrackingItems[]): void {
        this.state.externalInfo.trackingItems = values
    }

    private async _getInfoGeneralViewNavigationItems(): Promise<void> {
        let params:StatisticalAnalysisGeneralStatisticsDossierBaseRequest = generalStatisticsDossierService.getBaseRequest(this.state.externalInfo)
        params.sameRange = false
        const response: StatisticalAnalysisGeneralStatisticsDossierCase = await this.$_toCallSecure<StatisticalAnalysisGeneralStatisticsDossierCase>(generalStatisticsDossierService.getGeneralView(params, this.state.externalInfo.typeSearch!)) as StatisticalAnalysisGeneralStatisticsDossierCase
        this.state.headerData.navigationItems = this._transformNavigationItems(response)
        this.state.headerData.header.total = response.total
    }

    private _transformNavigationItems(data:StatisticalAnalysisGeneralStatisticsDossierCase): StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes>[] {
        return data?.totalByState.map((item: StatisticalAnalysisGeneralStatisticsDossierCaseVirtualState) => this._getItem(item) as StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes>)
    }

    private _getItem(item: StatisticalAnalysisGeneralStatisticsDossierCaseVirtualState): StatisticsAnalysisGeneralStatisticsTrackingItems | StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes> {
        return {
            label: item.state?.name,
            key: item.state?.code,
            value: item.total,
            icon: 'far fa-envelope-open-text'
        }
    }
}
